const Send = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.426 11.428L4.42601 3.428C4.25484 3.34702 4.06418 3.31635 3.87625 3.33957C3.68833 3.36279 3.51087 3.43895 3.36456 3.55916C3.21825 3.67937 3.10912 3.83868 3.04989 4.01854C2.99066 4.19839 2.98376 4.39138 3.03001 4.575L4.96901 12.333L3.03001 20.091C2.98333 20.2747 2.98992 20.4679 3.04902 20.648C3.10811 20.828 3.21726 20.9876 3.3637 21.1079C3.51014 21.2282 3.68782 21.3043 3.87594 21.3274C4.06406 21.3504 4.25486 21.3194 4.42601 21.238L21.426 13.238C21.5978 13.1572 21.7431 13.0293 21.8448 12.869C21.9466 12.7087 22.0006 12.5228 22.0006 12.333C22.0006 12.1432 21.9466 11.9573 21.8448 11.797C21.7431 11.6367 21.5978 11.5088 21.426 11.428ZM5.48101 18.53L6.32001 15.173L12 12.333L6.32001 9.493L5.48101 6.136L18.651 12.333L5.48101 18.53Z"
        fill={color}
      />
    </svg>
  );

  const solid = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.426 11.4282L4.42601 3.42817C4.25482 3.34763 4.0643 3.31729 3.87657 3.34069C3.68883 3.36408 3.51158 3.44026 3.36541 3.56036C3.21923 3.68046 3.11012 3.83957 3.05076 4.0192C2.99139 4.19883 2.98419 4.39162 3.03001 4.57517L4.24201 9.42417L12 12.3332L4.24201 15.2422L3.03001 20.0912C2.98333 20.2749 2.98992 20.4681 3.04902 20.6481C3.10811 20.8282 3.21726 20.9877 3.3637 21.1081C3.51014 21.2284 3.68782 21.3045 3.87594 21.3276C4.06406 21.3506 4.25486 21.3196 4.42601 21.2382L21.426 13.2382C21.5978 13.1574 21.7431 13.0294 21.8448 12.8692C21.9466 12.7089 22.0006 12.523 22.0006 12.3332C22.0006 12.1433 21.9466 11.9574 21.8448 11.7972C21.7431 11.6369 21.5978 11.5089 21.426 11.4282Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Send;
